import React from 'react';
import { Helmet } from 'react-helmet';
import favicon from '../images/favicon.ico';

const dataLayer = 'window.dataLayer = window.dataLayer || [];';

const PageHead = () => (
  <Helmet
    htmlAttributes={{ lang: 'en' }}
    style={[{ cssText: `.grecaptcha-badge[data-style="bottomright"] { visibility: hidden; }` }]}
  >
    <meta name="referrer" content="origin" />
    <meta name="viewport" content="width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <meta name="googlebot" content="noindex,indexifembedded" />
    <link rel="icon" type="image/png" sizes="16x16" href={favicon} />
    <script>{dataLayer}</script>
  </Helmet>
);

export default PageHead;
